export default {
  mounted(el) {
    el
  }
}
